import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldSlash } from "@phosphor-icons/react";

export default function Unauthorized({ message }) {
  const { user } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center p-8" data-testid="unauthorized-screen">
      <div className="max-w-md text-center border border-[#FF3B30]/40 bg-[#FF3B30]/[0.04] p-8">
        <ShieldSlash size={32} className="text-[#FF3B30] mx-auto mb-3" />
        <div className="text-[10px] tracking-[0.3em] uppercase text-[#FF3B30] mb-2">Access Denied</div>
        <h2 className="font-heading text-2xl tracking-tighter mb-3">Restricted area</h2>
        <p className="text-sm text-zinc-400 leading-relaxed mb-5">
          {message || `Your role (${user?.role?.replace(/_/g," ") || "guest"}) cannot view this resource. All access is logged.`}
        </p>
        <button
          data-testid="unauthorized-back-btn"
          onClick={() => nav(user?.role === "supplier" ? "/supplier" : "/")}
          className="bg-[#FFB300] text-black font-bold uppercase tracking-widest text-xs px-4 py-2"
        >
          Return to safe zone
        </button>
      </div>
    </div>
  );
}

/** Wrap a route element to require user.role to be in allowed list */
export function RoleGate({ allow, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!allow.includes(user.role)) return <Unauthorized />;
  return children;
}
